import React from 'react';

const Table = props => {
    const { data, columns } = props;

    const tableHeader = (
        <thead>
            <tr>
                {columns.map(column => {
                    if (column.type) {
                        switch(column.type){
                            case 'button':{
                                return (
                                    <th key={column.id} data-automation-id={`th_${column.id}_header`} scope="col" className={column.columnParentClasses}>
                                        <input type="button" {...column.attributes} value={column.text} onClick={column.handler} className={column.classes} /> 
                                    </th>
                                );
                            }
                            case 'link' : {
                                return (
                                    <th key={column.id} data-automation-id={`th_${column.id}_header`} className={column.columnParentClasses} scope="col">
                                        <a href={column.handler} className={column.classes}>{column.text}</a> 
                                    </th>
                                );
                            }
                        }                        
                    }else{
                        return (                    
                            <th key={column.id} data-automation-id={`th_${column.id}_header`} scope="col">
                                {column.text}
                            </th>
                        );
                    }
                } )}
            </tr>
        </thead>
    );

    const tableBody = (
        <tbody>
            {
                data.map((row, index) => (
                    <tr key={index}>
                        {
                            columns.map((column, index) => (
                                <td key={index} data-automation-id={`th_${column.id}_${index}`}>
                                    {row[column.id] }
                                </td>
                            ))}
                    </tr>
                ))
            }
        </tbody>);
    
    return (
        <div className="gi-table__responsive">
            <table className="usa-table usa-table--borderless gi-usa-table">
                {tableHeader}
                {data.length > 0 ? tableBody : null }                
            </table>
        </div>
    );
};

export default Table;